<script lang="ts">
	import { ImageSize, getImageUrl } from './utils';

	interface Props {
		cover: BaseUploadFile;
		size?: ImageSize;
		alt?: string;
		class?: string;
	}

	let {
		cover,
		size = ImageSize.NONE,
		alt = cover.alternativeText,
		class: clazz = ''
	}: Props = $props();
</script>

<img src={getImageUrl(cover, size)} class={clazz} width={cover.width} height={cover.height} {alt} />
